module.exports = __webpack_public_path__ + "img/95.498fa8ad.jpg";